import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@devhop/ui";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { Coffee, MoreHorizontal } from "lucide-react";
import {
  isPOSMoreMenuActive,
  POS_MORE_NAV,
  POS_PRIMARY_NAV,
} from "./pos-nav-config";

export function POSNavRail({ className }: { className?: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSettingsActive = isPOSMoreMenuActive(pathname);

  return (
    <TooltipProvider delayDuration={200}>
      <aside
        className={cn(
          "z-50 hidden w-20 shrink-0 flex-col items-center gap-1 border-r bg-sidebar py-3 lg:flex",
          className,
        )}
      >
        <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground">
          <Coffee className="h-6 w-6" />
        </div>

        <nav className="flex flex-1 flex-col items-center gap-1">
          {POS_PRIMARY_NAV.map((item) => {
            const active = item.isActive(pathname);
            const Icon = item.icon;
            return (
              <Tooltip key={item.key}>
                <TooltipTrigger asChild>
                  <button
                    type="button"
                    onClick={() => navigate(item.navigate())}
                    className={cn(
                      "flex h-16 w-16 flex-col items-center justify-center gap-1 rounded-xl font-medium text-[11px] transition-colors",
                      active
                        ? "bg-primary text-primary-foreground shadow-sm"
                        : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                    )}
                  >
                    <Icon className="h-5 w-5" />
                    <span className="line-clamp-1 max-w-full px-0.5">
                      {item.label.split(" ")[0]}
                    </span>
                  </button>
                </TooltipTrigger>
                <TooltipContent side="right">{item.label}</TooltipContent>
              </Tooltip>
            );
          })}
        </nav>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant={isSettingsActive ? "secondary" : "ghost"}
              size="icon"
              className="h-12 w-12 rounded-xl"
            >
              <MoreHorizontal className="h-5 w-5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="right" align="end">
            <DropdownMenuLabel>ເພີ່ມເຕີມ</DropdownMenuLabel>
            {POS_MORE_NAV.map((item) => {
              const Icon = item.icon;
              if (item.externalHref) {
                return (
                  <DropdownMenuItem
                    key={item.key}
                    onClick={() => window.open(item.externalHref, "_blank")}
                  >
                    <Icon className="mr-2 h-4 w-4" />
                    {item.label}
                  </DropdownMenuItem>
                );
              }
              if (!item.navigate) return null;
              return (
                <DropdownMenuItem
                  key={item.key}
                  onClick={() => navigate(item.navigate!())}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  {item.label}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      </aside>
    </TooltipProvider>
  );
}
